export function getAvatars(state) {
  return state.avatar.byId;
}

export function getDefaultAvatarId(state) {
  const defaultAvatarId = state.avatar.defaultAvatarId;
  if (defaultAvatarId) {
    return defaultAvatarId;
  }
  const avatars = getAvatars(state);
  const avatarsArray = Object.values(avatars).filter(
    (avatar) => avatar.deleted === false
  );
  if (avatarsArray.length === 0) return null;
  return avatarsArray[0].objectId;
}

export function getDefaultAvatar(state) {
  const defaultAvatarId = getDefaultAvatarId(state);
  const avatars = getAvatars(state);
  return avatars[defaultAvatarId];
}

export function getAvatarById(state, id) {
  return getAvatars(state)[id];
}

export function getYoungestAvatar(state) {
  const avatars = Object.values(getAvatars(state)).filter(
    (avatar) => avatar.deleted === false
  );

  if (!avatars || avatars.length === 0) {
    return getDefaultAvatar(state);
  }
  const youngestAvatar = avatars?.reduce((a, b) => {
    return new Date(a.birthDate) > new Date(b.birthDate) ? a : b;
  });

  if (!youngestAvatar) return getDefaultAvatar(state);
  return youngestAvatar;
}
